module.exports = __webpack_public_path__ + "img/six_red.ece53b38.png";